export default __webpack_public_path__ + "media/images/banner/banner-21-bc7f3fc9324b574b15f188fdbe10df05.jpg";